import { customElement, property, query } from 'lit/decorators.js';
import { WEB_COMPONENT_EASM_ASN_MAP } from '../../../../webcomponents.constants';
import { GzGenericWidgetContent } from '../../../../genericDashboard/gzGenericWidget';
import { html, TemplateResult } from 'lit';
import { GzMapWithBubblesChartWebComponent } from '../../../../ui/gzMapWithBubblesChart';
import { EasmAsnMapPayload } from '@nirvana/shared/dtos/types/widgets/common';
import { MapChartEvents, MapConfig } from '../../../../ui/gzMapWithBubblesChart/types';
import { removedCountries } from '../utils';
import { store } from '../../../../redux/store';
import { selectDashboardFilterValues } from '../../../../genericDashboard/redux/dashboard.filters.slice';
import { GenericDashboardsFiltersHelper } from '@nirvana/shared/dtos/types/generic-dashboards/gz-console';
import { generateFiltersForInventory } from '../../../utils/utils';
import { NavigationHelper } from '@nirvana/shared/navigation';
import { FilterType } from '../../genericTopData/types/types';
import { latLongCountries } from '../../../../ui/gzMapWithBubblesChart/utils/country-codes-lat-long';

@customElement(WEB_COMPONENT_EASM_ASN_MAP)
export class GzEasmAsnMapReportsWebComponent extends GzGenericWidgetContent {
  @property({
    type: Object,
    attribute: true,
    reflect: true,
  })
  payload: EasmAsnMapPayload;

  @query('gz-map-with-bubbles-chart')
  private gzMapWithBubblesChart: GzMapWithBubblesChartWebComponent;

  protected handleResize(): void {
    super.handleResize();

    if (!this.parentElement) {
      return;
    }

    this.gzMapWithBubblesChart?.resizeMap();
  }

  public renderLoader(): TemplateResult {
    return html` <gz-loader rows="1" columns="1" style="margin-top: calc(var(--spacer) * 4)"></gz-loader> `;
  }

  public renderContent(): TemplateResult {
    const mapConfig: MapConfig = {
      removedCountries: removedCountries,
    };

    return html` <gz-map-with-bubbles-chart
      .bubblesData=${this.payload?.easmAsnMap}
      .state=${this.state}
      .mapConfig=${mapConfig}
    ></gz-map-with-bubbles-chart>`;
  }

  firstUpdated(): void {
    super.firstUpdated();

    this.addEventListener(MapChartEvents.BUBBLE_CLICK, async (event: CustomEvent) => {
      await this.navigateToInventory(event);
    });
  }

  private async navigateToInventory(event: CustomEvent): Promise<void> {
    const dashboardAppState = store.getState().dashboardsApp;
    const filters = selectDashboardFilterValues(dashboardAppState);
    const companyId = GenericDashboardsFiltersHelper.getCompanyIdFromSingleSelectCompanyFilter(filters) as string;

    const country = latLongCountries.find(c => c.country === event.detail.label);

    if (!country) {
      return;
    }

    const filtersToSend = generateFiltersForInventory(FilterType.COUNTRY, '', companyId, [country.alpha2]);

    await NavigationHelper.navigateToEASMArtifactsInventory({
      smartViewId: this.payload?.inventorySmartViewId as string,
      filters: filtersToSend,
    });
  }

  public async handleTitleClick() {
    const dashboardAppState = store.getState().dashboardsApp;
    const filters = selectDashboardFilterValues(dashboardAppState);
    const companyId = GenericDashboardsFiltersHelper.getCompanyIdFromSingleSelectCompanyFilter(filters) as string;
    const filtersToSend = generateFiltersForInventory(FilterType.NONE, null, companyId);
    await NavigationHelper.navigateToEASMArtifactsInventory({
      smartViewId: this.payload?.inventorySmartViewId as string,
      filters: filtersToSend,
    });
  }
}
